(() => {
  if (customElements.get('trust-logo-marquee')) return;
  customElements.define('trust-logo-marquee', class extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('.trust-logos');
      this.list = this.querySelector('.trust-logos__list');
      if (!this.list) return;
      this.media = matchMedia('(max-width: 767px) and (prefers-reduced-motion: no-preference)');
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.media.addEventListener('change', () => this.setup(), { signal });
      this.addEventListener('focusin', () => { this.paused = true; }, { signal });
      this.addEventListener('focusout', () => { this.paused = false; }, { signal });
      document.addEventListener('visibilitychange', () => { this.previous = null; }, { signal });
      this.observer = new ResizeObserver(() => this.setup());
      this.observer.observe(this.container);
      this.setup();
    }
    reset() {
      cancelAnimationFrame(this.frame);
      this.list.querySelectorAll('[data-marquee-clone]').forEach((item) => item.remove());
      this.list.style.removeProperty('transform');
      this.container.classList.remove('trust-logos--running');
      this.previous = null;
    }
    setup() {
      this.reset();
      const originals = [...this.list.children];
      if (!originals.length) return;
      const containerStyle = getComputedStyle(this.container);
      const contentWidth = this.container.clientWidth - parseFloat(containerStyle.paddingLeft) - parseFloat(containerStyle.paddingRight);
      this.list.style.setProperty('--tl-mobile-width', `${contentWidth / Math.min(originals.length, 3)}px`);
      if (!this.media.matches || originals.length <= 3) return;
      this.container.classList.add('trust-logos--running');
      this.list.scrollLeft = 0;
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      this.distance = originals.reduce((total, item) => total + item.getBoundingClientRect().width + gap, 0);
      if (!this.distance) return;
      const repeats = Math.ceil(this.container.clientWidth / this.distance) + 1;
      for (let i = 0; i < repeats; i++) {
        originals.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.dataset.marqueeClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
          clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
          this.list.append(clone);
        });
      }
      this.offset = 0;
      const speed = Math.min(150, Math.max(5, Number(this.dataset.speed) || 30));
      this.list.style.transform = 'translateX(0px)';
      const animate = (time) => {
        if (this.previous !== null && !this.paused && !document.hidden) {
          // Pixels per second: the speed stays constant across screen widths.
          this.offset = (this.offset + (time - this.previous) * speed / 1000) % this.distance;
        }
        this.previous = time;
        this.list.style.transform = `translateX(${-this.offset}px)`;
        this.frame = requestAnimationFrame(animate);
      };
      this.frame = requestAnimationFrame(animate);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.list) this.reset();
    }
  });
})();
